// src/services/customerService.js
import axios from 'axios';
import { API_BASE_URL } from '../config';
import api from './api';

// Funktion zum Abrufen des CSRF-Tokens
function getCsrfToken() {
    return document.cookie.split('; ')
        .find(row => row.startsWith('csrftoken='))
        ?.split('=')[1];
}

const API_URL = `${API_BASE_URL}/customers/`;

export const getAllCustomers = async () => {
    try {
        const response = await axios.get(`${API_URL}`, {
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCsrfToken()
            },
            withCredentials: true
        });
        console.log('Customer API Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching customers:', error);
        throw error;
    }
};

export const searchCustomer = async (name) => {
    try {
        const response = await axios.get(`${API_URL}`, {
            params: { search: name },
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCsrfToken()
            },
            withCredentials: true
        });
        console.log('Customer API Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error searching customers:', error);
        throw error;
    }
};

export const addCustomer = async (customerData) => {
    try {
        const response = await api.post('/customers/', customerData);
        console.log('Customer API Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error adding customer:', error);
        throw error;
    }
};

export const updateCustomer = async (customerData) => {
    try {
        const response = await axios.put(`${API_URL}${customerData.id}/`, customerData, {
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCsrfToken()
            },
            withCredentials: true
        });
        console.log('Customer API Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error updating customer:', error);
        throw error;
    }
};

export const deleteCustomer = async (customerId) => {
    try {
        const response = await axios.delete(`${API_URL}${customerId}/`, {
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCsrfToken()
            },
            withCredentials: true
        });
        console.log('Customer API Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error deleting customer:', error);
        throw error;
    }
};

export const getCustomerById = async (id) => {
    try {
        const response = await axios.get(`${API_URL}${id}/`, {
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCsrfToken()
            },
            withCredentials: true
        });
        console.log('Customer API Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching customer by id:', error);
        throw error;
    }
};

export const getMyCustomers = async () => {
    try {
        const response = await axios.get(`${API_URL}my_customers/`, {
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCsrfToken()
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching my customers:', error);
        throw error;
    }
};
